import { LoadingState } from './ui/Primitives';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { notifyContentPreferencesChanged, subscribeContentPreferences } from '../utils/contentPreferences';

const url = () => `${process.env.REACT_APP_BACKEND_HOST}/v2/account/content-preferences`;
const options = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('jwt_authorization')}` } });

export default function ContentPreferences() {
  const [hide, setHide] = useState(true);
  const [loaded, setLoaded] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [notice, setNotice] = useState('');
  useEffect(() => {
    let active = true;
    let request = 0;
    const load = async () => {
      const current = ++request;
      setLoaded(false);
      setHide(true);
      try {
        const response = await axios.get(url(), options());
        if (active && current === request) { setHide(response.data.hideInappropriateContent !== false); setLoaded(true); setError(''); }
      } catch (_) { if (active && current === request) setError('Content preferences could not be loaded.'); }
    };
    load();
    const unsubscribe = subscribeContentPreferences(load);
    return () => { active = false; unsubscribe(); };
  }, []);
  const save = async event => {
    const next = event.target.checked;
    setBusy(true); setError(''); setNotice('');
    try {
      const response = await axios.put(url(), { hideInappropriateContent: next }, options());
      setHide(response.data.hideInappropriateContent !== false);
      notifyContentPreferencesChanged();
      setNotice('Content preference saved.');
    } catch (_) { setError('Your preference was not saved. Please try again.'); }
    finally { setBusy(false); }
  };
  return <section className="account-security-card account-content-card">
    <h2>Content preferences</h2>
    <label className="account-content-preference">
      <span className="account-preference-copy"><strong id="account-content-label">Hide inappropriate caller content</strong><span id="account-content-description">Hide inappropriate wording in transcripts, summaries, and call previews. Emails and CRM deliveries remain redacted.</span></span>
      <span className="account-toggle"><input type="checkbox" aria-labelledby="account-content-label" aria-describedby="account-content-description" checked={hide} onChange={save} disabled={!loaded || busy} /><span className="account-toggle-track" aria-hidden="true" /></span>
    </label>
    {!loaded && !error ? <LoadingState label="Loading content preferences…" /> : null}
    {notice ? <p role="status">{notice}</p> : null}
    {error ? <p role="alert" className="account-error">{error}</p> : null}
  </section>;
}
